import { apiClient } from '../config/ApiClient';
import type { OrderDTO } from '../dto/order/OrderDTO';

export interface CartPayload {
  itemId: string;
  itemOptionId: string;
  quantity: number;
}

export const getOpenCart = async (): Promise<OrderDTO | null> => {
  try {
    const res = await apiClient.get<OrderDTO>('/orders/cart', {
      validateStatus: (s) => (s >= 200 && s < 300) || s === 204,
    });
    return (res.status === 204 ? null : res.data) as OrderDTO | null;
  } catch {
    return null;
  }
};

export const addToCart = (payload: CartPayload) =>
  apiClient.post<OrderDTO>('/orders/cart/add', payload);

export const removeFromCart = (payload: CartPayload) =>
  apiClient.delete<OrderDTO>('/orders/cart/remove', { data: payload });

export const initiateCheckout = () =>
  apiClient.post<Record<string, any>>('/orders/checkout');

export const placeOrder = () => apiClient.post<OrderDTO>('/orders/place');

export const getOrderHistory = async (): Promise<OrderDTO[]> => {
  const res = await apiClient.get<OrderDTO[]>('/orders/history', {
    validateStatus: (s) => (s >= 200 && s < 300) || s === 204,
  });
  return res.status === 204 ? [] : res.data ?? [];
};
